import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_QUERY } from '../graphql/queries'
import { FETCH_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES } from '../redux/action-types'
import { cleanupFetchLocationTypesAndLocationTypeCategories } from '../redux/actions'

const useLocationTypesAndLocationTypeCategoriesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchLocationTypesAndLocationTypeCategories)

  const { isLoading, error, initialData, latestEvent } = useSelector(
    store => store.locationTypes.locationTypesAndLocationTypeCategories,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_QUERY,
        {},
        dispatch,
        FETCH_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES,
      ),

    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, initialData, latestEvent }
}

export default useLocationTypesAndLocationTypeCategoriesQuery
